<footer class="footer">
  <div class="footer-container">

    <div class="footer-brand">
      <img href="/" src="/logoBranca.png" alt="CuidaZap" class="footer-logo">

      <p class="footer-description">
        Um assistente via WhatsApp para<br>
        lembrar remédios, consultas e estar<br>
        sempre por perto de quem você ama.
      </p>

      <div class="footer-company">
        <span>CNPJ: 48.165.007/0001-83</span>
        <span>© 2025 CuidaZap</span>
        <span>Todos os direitos reservados.</span>
      </div>
    </div>

    <div class="footer-column">
      <h3>Contatos</h3>

      <a href="https://wa.me/5511965721445?text=Quero+saber+mais+sobre+o+CuidaZap&utm_source=chatgpt.com">
        (11) 96572-1445
      </a>
    </div>

    <div class="footer-column">
      <h3>Redes Sociais</h3>

      <a href="https://www.instagram.com/cuidazap/" target="_blank">Instagram</a>
      <a href="https://www.facebook.com/people/CuidaZap/61576619717674/?ref=PROFILE_EDIT_xav_ig_profile_page_web#" target="_blank">Facebook</a>
      <a href="https://www.linkedin.com/company/cuidazap/" target="_blank">LinkedIn</a>
    </div>

    <div class="footer-column">
      <h3>Acessos</h3>

      <a href="https://painel.cuidazap.com/checkout">Assine</a>
      <a href="https://cuidazap.com/quem-somos">Quem Somos</a>
      <a href="https://cuidazap.com/termos-de-uso">Termos de Uso</a>
      <a href="https://cuidazap.com/politica-de-privacidade">Política de Privacidade</a>
    </div>

  </div>
</footer>
